import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const BrandLogoSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const brandSlides = [
    [
      { name: 'BMW', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/b4437e5b63d5841188dbe10d83110cbc92bf40177b29cfe02e6fb234e9db0860.jpeg' },
      { name: 'Mercedes-Benz', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/dba705c689251fbee5d5da7b9e912ebd4589838b795784301a5d299cd1713151.jpeg' },
      { name: 'Audi', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/924d75a4fd303d2886f718a223dfa70f295e0174f8c116492df0e4a5d708454a.jpeg' },
      { name: 'Porsche', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/28c3dc3a765630f94613596bacb0a895fbd4f3f8b4220a5c360ca44a54ef504a.jpeg' },
      { name: 'Volkswagen', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/2d44248e26a6a9d1c35897e020c984b3a963c25fbf33b71c21dc770b21130ce2.jpeg' },
      { name: 'Lamborghini', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/91088ae325cec15964f9fb219decb139d953fcb19a22b6c8e879ee5dfd2ba058.jpeg' },
      { name: 'Bentley', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/12078e69379e6cda042b0edeef058b01cf71d42af864836b07ae78b9e0b6e84f.jpeg' },
      { name: 'Rolls-Royce', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/093639c003de8301adbc61ae17b1a8e13f964c20cbaffc0fe610a5e5741f39e5.jpeg' }
    ],
    [
      { name: 'Ferrari', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/2173a60267b5fa29b62e5a819f5e63cdc0bf271fa0e2cd65dec64f737ebf3308.jpeg' },
      { name: 'Land Rover', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/c6428423cf57062536bd681ad01f79f3907223827bc84c2a6fdcf48169016547.jpeg' },
      { name: 'McLaren', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/6be93f93dbea9c74158fbd6c10197be2869022f89f11d00a64eb0661f65501b2.jpeg' },
      { name: 'Aston Martin', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/3012e563d2c0d8a756dd34f26c0cbd3636ac265a7632c1c924ef0e0c5fe18092.jpeg' },
      { name: 'Jaguar', logo: 'https://static.prod-images.emergentagent.com/jobs/62cbec4e-40c3-4c85-8612-7a52ef4a5653/images/2a62d60e55cd938a057af98322f929da27c68f8c12908cd438952aaa34d0a0bc.jpeg' }
    ]
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % brandSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + brandSlides.length) % brandSlides.length);
  };

  return (
    <div className="w-full bg-black py-8 md:py-20 relative">
      {/* Title Section */}
      <div className="container mx-auto px-4 mb-6 md:mb-16">
        <div className="flex items-center justify-center mb-2 md:mb-4">
          <div className="h-px bg-red-600 w-6 md:w-16"></div>
          <h3 className="text-red-600 font-bold text-xs md:text-lg mx-2 md:mx-4 tracking-wider">WE SPECIALIZE IN</h3>
          <div className="h-px bg-red-600 w-6 md:w-16"></div>
        </div>
        <h2 className="text-white text-xl sm:text-2xl md:text-5xl font-bold text-center mb-2 px-2">
          GERMAN & EUROPEAN VEHICLES
        </h2>
        <div className="flex justify-center">
          <div className="h-1 bg-red-600 w-16 md:w-32"></div>
        </div>
      </div>

      {/* Logos Grid */}
      <div className="relative max-w-7xl mx-auto px-8 md:px-16">
        {/* Left Arrow - Hidden on mobile */}
        <button
          onClick={prevSlide}
          className="hidden md:block absolute left-0 top-1/2 -translate-y-1/2 z-10 text-red-600 hover:text-red-500 transition-colors"
          aria-label="Previous slide"
        >
          <ChevronLeft className="w-12 h-12" />
        </button>

        {/* Right Arrow - Hidden on mobile */}
        <button
          onClick={nextSlide}
          className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 z-10 text-red-600 hover:text-red-500 transition-colors"
          aria-label="Next slide"
        >
          <ChevronRight className="w-12 h-12" />
        </button>

        {/* Grid Container */}
        <div className="overflow-hidden">
          <div 
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {brandSlides.map((slide, slideIndex) => (
              <div key={slideIndex} className="w-full flex-shrink-0">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-0">
                  {slide.map((brand, index) => (
                    <div 
                      key={index}
                      className="flex flex-col items-center justify-center py-6 md:py-12 border-r border-gray-800 last:border-r-0 odd:border-r md:border-r"
                      style={{ 
                        borderTop: index >= 2 ? '1px solid rgb(31, 41, 55)' : 'none'
                      }}
                    >
                      <div className="mb-3 md:mb-6 flex items-center justify-center h-24 md:h-32 w-full px-4">
                        <img
                          src={brand.logo}
                          alt={brand.name}
                          className="max-w-[120px] sm:max-w-[130px] md:max-w-[140px] max-h-20 md:max-h-28 object-contain opacity-90"
                          style={{ backgroundColor: '#000000' }}
                        />
                      </div>
                      <div className="text-white text-xs sm:text-sm md:text-lg font-normal tracking-wide px-2 text-center">
                        {brand.name}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Pagination Dots */}
        <div className="flex justify-center mt-4 md:mt-8 space-x-2 md:space-x-3">
          {brandSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2.5 h-2.5 md:w-3 md:h-3 rounded-full transition-all duration-300 ${
                currentSlide === index ? 'bg-red-600 w-6 md:w-8' : 'bg-gray-600'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Mobile Navigation Arrows */}
        <div className="flex md:hidden justify-center items-center space-x-6 mt-4">
          <button
            onClick={prevSlide}
            className="text-red-600 hover:text-red-500 transition-colors p-2"
            aria-label="Previous slide"
          >
            <ChevronLeft className="w-8 h-8" />
          </button>
          <button
            onClick={nextSlide}
            className="text-red-600 hover:text-red-500 transition-colors p-2"
            aria-label="Next slide"
          >
            <ChevronRight className="w-8 h-8" />
          </button>
        </div>
      </div>
    </div>
  );
};
